interface Props {
  className?: string;
}

/**
 * The Global Tote mark.
 *
 * Inlined rather than loaded from /logo.svg so the two dark slashes can follow
 * the theme -- at #0b1315 they would disappear against the dark background.
 */
export function Logo({ className }: Props) {
  return (
    <svg
      viewBox="0 0 516.63 516.63"
      className={className}
      role="img"
      aria-label="Global Tote"
    >
      <circle cx="258.32" cy="258.32" r="258.32" fill="#33b0ce" />
      <path
        d="M368.54,128.23l-152.59,260.18h-67.86l152.59-260.18h67.86Z"
        fill="#fff"
      />
      <path
        d="M461.23,128.23l-152.59,260.18h-67.86l152.59-260.18h67.86Z"
        className="fill-[#0b1315] dark:fill-[#04262e]"
      />
      <path
        d="M275.86,128.23L123.26,388.41H55.41L208,128.23h67.86Z"
        className="fill-[#0b1315] dark:fill-[#04262e]"
      />
    </svg>
  );
}
